export default __webpack_public_path__ + "assets/9d5c08185b8aad6d1553d7831738250d.svg";